import type { TagDef } from '@chewy/chat-library-common';
import { KibProductBadges } from '@chewy/kib-product-react';
import '@chewy/kib-product-styles/dist/styles/kib-product-badges.css';
import styles from './Tags.module.scss';

export interface TagsProps {
  tags: TagDef[];
}

function kibBadgePropValue(tag: TagDef): boolean | TagDef['label'] {
  // KibProductBadges uses built-in labels per badge type when the prop is `true`.
  // Pass a string/ReactNode only when callers set `label` on TagDef (override).
  if (tag.label === undefined || tag.label === null) return true;
  if (typeof tag.label === 'string' && tag.label === '') return true;
  return tag.label;
}

export default function Tags({ tags }: TagsProps) {
  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <div className={styles.tags}>
      <KibProductBadges
        {...Object.assign({}, ...tags.map((tag) => ({ [tag.Icon]: kibBadgePropValue(tag) })))}
      />
    </div>
  );
}
